export default __webpack_public_path__ + "static/fire_protection_w.4afb1624057ed93270d00cda515b3469.svg";